<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm
                  ref="form"
                  @submit.prevent="onSubmitForm"
                >
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <CInput
                    placeholder="Username"
                    autocomplete="username email"
                    name="username"
                    required
                    v-model="formData.login"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    name="password"
                    required
                    v-model="formData.password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        type="submit"
                        color="primary"
                        class="px-4"
                        :disabled="loading"
                      >Login</CButton>
                      <VErrorResponce
                        class="pt-2"
                        :error="error"
                      ></VErrorResponce>
                    </CCol>
                    
                  </CRow>
                  <CRow>
                    <CCol col="12">
                      <CButton @click="openModal" color="link" class="px-0">Reset Your Password?</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody class="h-100 d-flex align-items-center justify-content-center">
                <!-- <img src="images/logo-light.svg" alt=""> -->
                <img src="https://evbids.blob.core.windows.net/assets/images/tesla_logo.png" class="c-sidebar-brand-full" height="45" />
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import VErrorResponce from '@/components/VErrorResponce'
import { authStore, createAuthStoreMixin } from '@/mixins/authStoreMixin'
import ModalType from '@/utils/dictionaries/modalType'

export default {
  name: 'Login',

  mixins: [
    createAuthStoreMixin()
  ],

  components: {
    VErrorResponce
  },

  computed: {
    loggedIn () {
      return this[authStore.getterTypes.GETTER_IS_AUTHENTICATED]
    }
  },

  data: () => ({
    loading: false,
    error: null,
    formData: {
      login: null,
      password: null
    }
  }),

  methods: {
    openModal(){
      this.$modals.open(ModalType.ForgotPasswordModal)

    },
    async onSubmitForm () {
      this.error = null

      try {
        this.loading = true
        await this[authStore.actionTypes.ACTION_SIGN_IN](this.formData)
        // this.$router.push('/')
        window.location.href = '/'
      } catch (error) {
        this.error = error.response && error.response.data
      } finally {
        this.loading = false
      }
    }
  },

  mounted () {
    // if (this.loggedIn) {
    //   this.$router.push('/')
    // }
  }
}
</script>
